<template>

           <div class="container">
                <div class="page-header">
                    <div class="page-title">

                        <div class="crumbs">
                            <ul id="breadcrumbs" class="breadcrumb">
                                <li>
                                  <router-link :title="'الرئيسيه'" :to="{name: 'dashboard'}"> <i class="flaticon-home-fill"></i> الرئيسيه</router-link>
                                </li>
                                <li class="active">
                                  <router-link :title="'اولياء الامور'" :to="{name: 'parents'}">اولياء الامور</router-link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-lg-12 col-md-12 layout-spacing">
                        <div class="statbox widget box box-shadow">
                            <div class="widget-header">
                                <div class="row">
                                    <div class="col-xl-12 col-md-12 col-sm-12 col-12">
                                        <h4>
                                          جميع البيانات
                                        <create-button  v-if="hasPermissions('parents_create')" :routeName="'parents.create'"></create-button>

                                        </h4>
                                    </div>
                                </div>
                            </div>
                            <div class="widget-content widget-content-area">

                                <div class="table-responsive">
                                    <table class="table table-striped table-bordered">
                                      <tbody>
                                        <tr>
                                          <th>
                                            #
                                          </th>
                                          <td>
                                            <div class="dropdown custom-dropdown">
                                                <a class="dropdown-toggle" href="#" role="button" id="dropdownMenuLink1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                    <i class="flaticon-dot-three fs-17"></i>
                                                </a>

                                                <div class="dropdown-menu" aria-labelledby="dropdownMenuLink1">
                                                  <edit-button v-if="hasPermissions('parents_edit')" :routing="{name: 'parents.edit', params: {id: user.id}}"></edit-button>
                                                  <delete-button v-if="hasPermissions('parents_delete')" :deleteUrl="'/parents/' + user.id" :data="user" @deleteData="deleteData"></delete-button>
                                                </div>
                                          </div>


                                          </td>
                                        </tr>

                                        <tr>
                                          <th>
                                            الاسم
                                          </th>
                                          <td>
                                            {{ user.name }}
                                          </td>
                                        </tr>

                                        <tr>
                                          <th>
                                            رقم الجوال
                                          </th>
                                          <td>
                                            {{ user.mobile }}
                                          </td>
                                        </tr>


                                        <tr>
                                          <th>
                                            الصف
                                          </th>
                                          <td>
                                            {{ user.group ? user.group.name : '---' }}
                                          </td>
                                        </tr>

                                        <tr>
                                          <th>
                                            تاريخ الطلب
                                          </th>
                                          <td>
                                            {{ user.request_date }}
                                          </td>
                                        </tr>

                                        <tr>
                                          <th>
                                            حالة الطلب
                                          </th>
                                          <td>
                                            <span class="badge badge-warning" v-if="user.status == 'pending'">معلق</span>
                                            <span class="badge badge-danger" v-else-if="user.status == 'canceled'">مرفوض</span>
                                            <span class="badge badge-success" v-else>مقبول</span>
                                          </td>
                                        </tr>

                                      </tbody>
                                    </table>
                                    <table class="mt-5 table table-striped table-bordered">
                                      <thead>
                                        <tr>
                                          <th>اسم الطالب</th>
                                          <th>تاريخ الطلب الطلب</th>
                                          <th>المرحلة الدراسية</th>
                                          <th>الصف الدراسى</th>
                                          <th>حالة الطلب</th>
                                          <th>#</th>
                                        </tr>
                                      </thead>
                                      <tbody v-if="user.parent_requests">
                                        <tr v-for="(req, k) in user.parent_requests" :key="k">
                                          <td>{{req.name}}</td>
                                          <td>{{req.request_date}}</td>
                                          <td>{{req.stage.name}}</td>
                                          <td>{{req.group.name}}</td>
                                          <td>
                                            <span class="badge badge-warning" v-if="req.status == 0">غير مفعل</span>
                                            <span class="badge badge-success" v-else>قام بالمقابلة الشخصية</span>
                                          </td>
                                          <td>
                                             <router-link :title="'ترحيل الطالب للمقابلة الشخصية'"  v-if="user.status == 'accepted' && req.status == 0 && hasPermissions('interviews_create')" :to="{name: 'interviews.create', query: {parent: user.id, child: req.id}}">
                                               <span class="badge badge-danger">
                                               ترحيل الطالب للمقابلة الشخصية</span></router-link>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                </div>

                            </div>
                        </div>

                    </div>

                </div>
            </div>

</template>
<script>
import router from '@/router'

export default {
  data() {
    return {
      user: {},
      isRequested: false,
    };
  },
  created() {
    this.findOne();
  },
  methods: {
    findOne() {
      this.$baseApi.get('/parents/' + this.$route.params.id).then((response) => {
        if (response.data.code === 200 && response.data.data != null) {
          this.user = response.data.data;
          this.user.id = this.$route.params.id;
        } else if (response.data.code === 404) {
          router.push('/parents');
        } else {
          alert(response.data.error);
          router.push('/parents');
        }
      });
    },
    deleteData(data){
      router.push('/users');
    }
  },
  computed: {
    trans() {
      return this.$store.getters.GET_TRANS;
    }
  }
}

</script>
<style>
</style>
